import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import SEO from '../components/SEO';

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#FFFDF9]">
      {/* Header */}
      <header className="px-6 md:px-12 lg:px-24 py-6 border-b border-gray-100">
        <nav className="flex items-center justify-between max-w-4xl mx-auto">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="/logo.png" 
              alt="mobbing-melden.de Logo" 
              className="h-14 w-auto"
            />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-[#718096] hover:text-[#2D3748] transition-colors">
            <ChevronLeft className="w-4 h-4" />
            Zurück
          </Link>
        </nav>
      </header>

      {/* Content */}
      <main className="px-6 md:px-12 lg:px-24 py-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h1 className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-8" style={{ fontFamily: 'Nunito' }}>
            Impressum
          </h1>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-[#718096] mb-4">
              <strong>mobbing-melden.de c/o GAM</strong><br />
              Pappelallee 64<br />
              10437 Berlin, Deutschland
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Kontakt
            </h2>
            <p className="text-[#718096] mb-4">
              E-Mail: support@mobbing-melden.de
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="text-[#718096] mb-4">
              Michael W.<br />
              Pappelallee 64, 10437 Berlin
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Streitschlichtung
            </h2>
            <p className="text-[#718096] mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#A0E8AF] hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-[#718096] mb-4">
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p className="text-[#718096] mb-4">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Haftung für Inhalte
            </h2>
            <p className="text-[#718096] mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
              zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-[#718096] mb-4">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
              der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Haftung für Links
            </h2>
            <p className="text-[#718096] mb-4">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="text-[#718096] mb-4">
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche 
              Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht 
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Urheberrecht
            </h2>
            <p className="text-[#718096] mb-4">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. 
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="text-[#718096] mb-4">
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
              Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem 
              auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei 
              Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 md:px-12 lg:px-24 py-8 bg-white/50 border-t border-gray-100">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#A0AEC0]">
            © 2024 mobbing-melden.de
          </p>
          <div className="flex items-center gap-6">
            <Link to="/datenschutz" className="text-sm text-[#718096] hover:text-[#2D3748]">Datenschutz</Link>
            <Link to="/impressum" className="text-sm text-[#718096] hover:text-[#2D3748]">Impressum</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
